<div id="footer-bar">
  <button class="navButton" mat-icon-button
          aria-label="Current task list" title="Current task list (C)"
          routerLink="/current" routerLinkActive="active">
    <mat-icon>check</mat-icon>
  </button>
  <button class="navButton" mat-icon-button
          aria-label="Add task to Current list" title="Add task to Current list (A)"
          routerLink="/add/current" routerLinkActive="active">
    <mat-icon>add_circle</mat-icon>
  </button>
  <button class="navButton" mat-icon-button
          aria-label="Backlog task list" title="Backlog task list (B)"
          routerLink="/add/backlog" routerLinkActive="active">
    <mat-icon>view_list</mat-icon>
  </button>
  <button class="navButton" mat-icon-button
          aria-label="Sprint list" title="Sprint list (S)"
          routerLink="/sprints" routerLinkActive="active">
    <mat-icon>calendar_today</mat-icon>
  </button>
</div>
